module.exports = __webpack_public_path__ + "img/littleWx.71c11d53.png";